import { DanceManagerFeatureNameEnum, UpdateDanceManagerFeatureInterface } from '../../..';

export class UpdateDanceManagerFeatureRequestDto implements UpdateDanceManagerFeatureInterface{
  features: DanceManagerFeatureNameEnum[];
  force = false;
}
